<template>
	<swiper
		:direction="'horizontal'"
		:spaceBetween="20"
		:slidesPerView="isMobile && roles.length > 1 ? 1.25 : isMobile && roles.length == 1 ? 1 : 4"
		:centeredSlides="false"
		:freeMode="{ enabled: false, sticky: false }"
		:mousewheel="true"
		:class="'slider--boxes'"
	>
		<swiper-slide v-for="r in roles" :key="r.id">
			<BoxRole :role="r" @delete="(role) => $emit('delete', role)" :showDelete="showDelete" :showGoToDetail="showGoToDetail" />
		</swiper-slide>
	</swiper>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useStore } from '../../store';
import BoxRole from '../boxes/BoxRole.vue';

export default defineComponent({
	name: 'RoleSlider',
	data() {
		return {
			showInfo: false,
		};
	},
	components: {
		Swiper,
		SwiperSlide,
		BoxRole,
	},
	props: {
		roles: {
			type: Array as PropType<any[]>,
			required: true,
		},
		showGoToDetail: {
			type: Boolean,
			default: true,
		},
		showDelete: {
			type: Boolean,
			default: true,
		},
	},
	setup() {
		const store = useStore();
		const isMobile = computed(() => store.state.isMobile);

		return {
			store,
			isMobile,
		};
	},
});
</script>
